/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeCardLinkWithThreeDS} from '../api'

export const useMutationCompleteCardLinkWithThreeDS = createReactQueryMutationHook('completeCardLinkWithThreeDS', completeCardLinkWithThreeDS)
